import React, { useEffect, useState } from "react";
import { Modal, Switch, message } from "antd";
import { Plus, Pencil, RefreshCw, Plug } from "lucide-react";
import { requestJson } from "../api/httpClient";
import styles from "./SiteParsersPage.module.css";

const errorText = (error) => {
  try { return JSON.parse(error.message).message || error.message; } catch { return error.message; }
};
const connection = (item) => ({ code: item.code, name: item.name, enabled: item.enabled,
  endpoint: item.endpoint || "", version: item.version });

// [[Site Parser Registry]] #obsidian-marker
// [[Remote Parser Service]] #obsidian-marker
export default function SiteParsersPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [editing, setEditing] = useState(null);
  const [check, setCheck] = useState(null);
  const [testing, setTesting] = useState(false);
  const load = async () => {
    setLoading(true);
    try { setItems(await requestJson("/api/admin/site-parsers")); }
    catch (error) { message.error(errorText(error)); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);
  const persist = (item) => requestJson(`/api/admin/site-parsers${item.id ? `/${item.id}` : ""}`,
    { method: item.id ? "PUT" : "POST", body: connection(item) });
  const toggle = async (item, enabled) => {
    setSaving(true);
    try { await persist({ ...item, enabled }); await load(); message.success(enabled ? "Источник включён" : "Новые запуски отключены"); }
    catch (error) { message.error(errorText(error)); await load(); }
    finally { setSaving(false); }
  };
  const open = (item) => {
    setEditing(item ? { ...connection(item), id: item.id } : { code: "", name: "", enabled: false, endpoint: "" });
    setCheck(null);
  };
  const save = async () => {
    if (!editing.name.trim() || !editing.code.trim() || !editing.endpoint.trim()) {
      message.error("Укажите название, код и endpoint"); return;
    }
    setSaving(true);
    try { await persist({ ...editing, endpoint: editing.endpoint.trim() }); setEditing(null); await load(); message.success("Подключение сохранено"); }
    catch (error) { message.error(errorText(error)); }
    finally { setSaving(false); }
  };
  const test = async () => {
    setTesting(true); setCheck(null);
    try { setCheck(await requestJson("/api/admin/site-parsers/check", { method: "POST", body: { endpoint: editing.endpoint.trim() } })); }
    catch (error) { setCheck({ error: errorText(error) }); }
    finally { setTesting(false); }
  };
  return (
    <section className={styles.page}>
      <header className={styles.header}>
        <div><h2>Сайты и парсеры</h2><p>Подключения к сервису парсеров. Отключение запрещает новые запуски; начатые задания завершатся.</p></div>
        <div className={styles.actions}>
          <button type="button" onClick={load} disabled={loading}><RefreshCw size={16} />Обновить</button>
          <button type="button" onClick={() => open(null)}><Plus size={16} />Добавить сайт</button>
        </div>
      </header>
      <div className={styles.tableWrap}>
        <table><thead><tr><th>Сайт</th><th>Endpoint</th><th>Для всего приложения</th><th>Подключение</th></tr></thead>
          <tbody>{items.map((item) => <tr key={item.id}>
            <td><strong>{item.name}</strong><small>{item.code}</small></td><td>{item.endpoint || "Не настроен"}</td>
            <td><Switch checked={item.enabled} disabled={saving} onChange={(enabled) => toggle(item, enabled)}
              checkedChildren="Вкл" unCheckedChildren="Выкл" aria-label={`Включить ${item.name} для приложения`} /></td>
            <td><button type="button" onClick={() => open(item)}><Pencil size={15} />Настроить</button></td>
          </tr>)}</tbody>
        </table>
        {!items.length && <p>{loading ? "Загрузка…" : "Сайты ещё не добавлены"}</p>}
      </div>
      <Modal title={editing?.id ? `Подключение: ${editing.name}` : "Новый источник"} open={Boolean(editing)} width={750}
        onCancel={() => !saving && !testing && setEditing(null)} onOk={save} okText="Сохранить в БД" cancelText="Закрыть"
        confirmLoading={saving} okButtonProps={{ disabled: testing }} destroyOnClose>
        {editing && <div className={styles.editor}>
          <div className={styles.grid}>
            <label>Название<input value={editing.name} maxLength={120} disabled={testing} onChange={(e) => setEditing({ ...editing, name: e.target.value })} /></label>
            <label>Код сайта<input value={editing.code} disabled={Boolean(editing.id) || testing} placeholder="supplier-name" onChange={(e) => setEditing({ ...editing, code: e.target.value })} /></label>
          </div>
          <label>Endpoint<input type="url" value={editing.endpoint} disabled={testing} maxLength={1000}
            placeholder="http://server:8093/api/v1/parsers/chipdip/jobs"
            onChange={(e) => { setEditing({ ...editing, endpoint: e.target.value }); setCheck(null); }} /></label>
          <label className={styles.enabled}><Switch checked={editing.enabled} disabled={testing} onChange={(enabled) => setEditing({ ...editing, enabled })} />Включён для всего приложения</label>
          <p>Скопируйте полный endpoint источника из реестра сервиса парсеров. Ключ подключения настраивается на сервере приложения.</p>
          <div className={styles.preview}>
            <button type="button" disabled={testing || saving || !editing.endpoint.trim()} onClick={test}><Plug size={16} />{testing ? "Проверка…" : "Проверить подключение"}</button>
          </div>
          {check && <p role="status">{check.error || `${check.message}. ${check.enabled ? "Источник включён в сервисе." : "Источник отключён в сервисе — сбор недоступен."}`}</p>}
        </div>}
      </Modal>
    </section>
  );
}
